// extracted by mini-css-extract-plugin
export default {"iranianBanner":"IranianBanner_iranianBanner__qOV2y","banner":"IranianBanner_banner__8FH07","prices":"IranianBanner_prices__mAv9l"};